<template>
  <div>
    <div class="divButtonRigth">
      <!--<el-button type="primary" size="small" @click="updateBankInfo">更新银行信息</el-button>-->
      <el-button type="primary" size="small" @click="createPayoutBill">创建支出单</el-button>
      <el-button   type="primary" size="small" @click="exportTable">导出</el-button>
    </div>
    <bsp-table
      :data.sync="list"
      ref="privateTable"
      show-header-overflow
      show-overflow
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage"
      :show-pagination="listQuery.page"
      @ciic-data-select="_getselect"
    >
      <vxe-table-column type="selection" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column type="index" title="序号" width="50" align="center" fixed="left"/>
<!--      <bsp-table-column field="cusNum" title="客户编号" filter-type="input" width="130px" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.cusNum}}</span>-->
<!--        </template>-->
<!--      </bsp-table-column>-->
      <bsp-table-column field="cusName" title="客户名称" filter-type="input" width="250px" align="center" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.cusName}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column field="empName" title="雇员姓名" filter-type="input" width="130px" align="center" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.empName}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column field="identityNum" title="证件号码" filter-type="input" width="200px" align="center" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.identityNum}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column field="refundStatus" title="状态" filter-type="select" width="130px" align="center" set-id="3079">
        <template slot-scope="scope">
          <span>{{ scope.row.refundStatus | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="taxType"
        title="计税类型"
        width="130px"
        align="center"
        set-id="2004"
        filter-type="select"
      >
        <template slot-scope="scope">
          <span>{{scope.row.taxType | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="isSalary"
        title="是否薪资"
        width="130px"
        align="center"
        set-id="1002"
        filter-type="select"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isSalary | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="退票信息"  :grounpColumns="grounpColumns1" width="1500px" align="center"></bsp-table-column>
      <bsp-table-column title="更新银行信息"   :grounpColumns="grounpColumns2" width="1500px" align="center"></bsp-table-column>

      <bsp-table-column field="modifyTips" title="备注" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.modifyTips}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="操作" width="200px" fixed="right" align="center">
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button type="text" @click="privateEdit(scope.row)">手动更新编辑</el-button>
          </div>
        </template>
      </bsp-table-column>
    </bsp-table>
  <div v-if="dialogFormVisible">
    <el-dialog v-dialogDrag
               ref="dialogForm"
               width="70%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               title="更新"
               :visible.sync="dialogFormVisible"
               v-if="dialogFormVisible"
               :before-close="beforeClose"
    >
      <editPage @getbusinessReviewer="getbusinessReviewer(arguments)"
                ref="editPage"
                :list-form.sync="listForm"
                :refundId.sync="refundId"
                :empId.sync="this.empId"
                :tabName.sync="tabName"
      />
      <div class="marginTop30" style="text-align: center">
        <el-button type="primary" @click="savePrivateInfo()">
          保存
        </el-button>
        <el-button @click="cancelSubmit()">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getRefundListPage, updateRefundInfo, updateBankInfo, createPayoutBill} from "@/api/biz/refund/refund";
  import {getDicts,getServerDictsMap, getServerDictsList} from '@/api/sys/payment/code';
  import editPage from "./editPage";
  import exportMethod from "@/util/refund/export";
  import {mapGetters} from 'vuex';

  export default {
    name: "Table",
    components: {bspTableColumn, bspTable, editPage},
    props: {
      pageType: {
        type: String,
        default: '',
      },
      currentTab: {
        type: String,
        default: ''
      },
    },
    created() {
      this._getListpage();
    },
    watch: {
      currentTab: function (newVal, oldVal) {
        this.tabType = newVal;
        this._getListpage();
      }
    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    data() {
      return {
        dialogFormVisible: false,
        loading: false,
        serverDictsMap: null,
        serverDictsList: null,
        list: [],
        refundId: 0,
        empId: 0,
        selectRow: [],
        tabName: 'private',
        grounpColumns:[
          {field: "refundBankType", title: "退票银行", width: "120px", align: "center"},
          {field: "accountName", title: "开户名", width: "120px", align: "center"},
          {field: "detailBankType", title: "开户行", width: "120px", align: "center"},
          {field: 'accountNo', title: '开户账号', width: "120px", align: "center"},
          {field: 'bankFeedback', title: '退票原因', width: "150px", align: "center"},
          {field: 'amount', title: '退票金额', width: "120px", align: "center"},
          {field: 'recordTime', title: '退票时间', width: "120px", align: "center"},  {field: 'upOpenName', title: '开户名', width: "120px", align: "center"},
          {field: 'upBankType', title: '开户行', width: "120px", align: "center"},
          {field: 'upBankFullName', title: '开户行全称', width: "150px", align: "center"},
          {field: 'upAccountNumber', title: '开户账号', width: "150px", align: "center"},],
        grounpColumns1: [
          {field: "refundBankType", title: "退票银行", width: "120px", align: "center", setId: "1016", dataType: "dict"},
          {field: "accountName", title: "开户名", width: "120px", align: "center"},
          {field: "detailBankType", title: "开户行", width: "120px", align: "center", setId: "1016", dataType: "dict"},
          {field: 'accountNo', title: '开户账号', width: "150px", align: "center"},
          {field: 'bankFeedback', title: '退票原因', width: "150px", align: "center"},
          {field: 'amount', title: '退票金额', width: "120px", align: "center"},
          {field: 'recordTime', title: '退票时间', width: "120px", align: "center"},
        ],
        grounpColumns2: [
          {field: 'upOpenName', title: '开户名', width: "120px", align: "center"},
          {field: 'upBankType', title: '开户行', width: "120px", align: "center", setId: "1016", dataType: "dict"},
          {field: 'upBankFullName', title: '开户行全称', width: "180px", align: "center"},
          {field: 'upAccountNumber', title: '开户账号', width: "150px", align: "center"},
        ],
        tabType: '',
        listQuery: {
          limit: 50,
          page: 1,
          total: 0,
          headerRowNum: 1,
          tabType: 'private',
          isSort: true,// 是否加序号列
          dataList: [],// 页面勾选的数据用来作导出
          type: 'excel',// 导出类型
          beanName: 'refundServiceImpl',// 指定调用的那个savercie
          fileName: '对私退票信息.xls',// 导出的文件名
          methodName: 'refundListPage',// 指定调用的那个savercie 那个方法
          translates: [{field: 'refundStatus', type: 'code', param: '3079'},
            {field: 'taxType', type: 'code', param: '2004'},
            {field: 'isSalary', type: 'code', param: '1002'},
            {field: 'refundBankType', type: 'code', param: '1016'},
            {field: 'detailBankType', type: 'code', param: '1016'},
            {field: 'upBankType', type: 'code', param: '1016'}
            ]//要翻译的字段 field：字段  type：类型 code,cusRef,... ,param:参数 如果有多 cusId=1,cusId1=2
        },
        listForm: {
          addRtnCause: '',
          id: '',
        },
        textMap: {
          add: '新增',
          update: '编辑'
        },
        dialogStatus: 'add',
      }
    },
    methods: {
      getServerDictsMap() {
        getServerDictsMap().then(res => {
          console.log("排除后的项")
          console.log(res)
          this.serverDictsMap = res.data.data
        })
      },
      getServerDictsList() {
        getServerDictsList().then(res => {
          console.log("排除后的代码集")
          console.log(res)
          this.serverDictsList = res.data.data;
        })
      },
      //获取列表数据
      _getListpage() {
        this.loading = true;
        this.listQuery.tabType = this.currentTab;
        getRefundListPage(this.listQuery).then(res => {
          console.log("getRefundListPage===res=", res)
          this.listQuery.total = res.data.data.total
          this.list = res.data.data.records;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      privateEdit(row) {
       console.log("只有新增、退回状态的退票可以更新")
      console.log("row----------"+row)
        this.refundId = row.backId;
        this.empId = row.empId;
        console.log("privateEdit==this.refundId==", this.refundId);
        if(row.refundStatus!='30790001'&& row.refundStatus!='30790003'){
          this.$message.error("只有新增、退回状态的退票可以更新");
          return false;
        }
        this.dialogFormVisible = true;
      },
      privateUpdate() {
        this.$message.success("success");
      },
      beforeClose() {
        this.cancelSubmit();
      },
      cancelSubmit() {
        // console.log("把子面from表单清空");
        // 把子面from表单清空
        //this.$refs.testForm.$refs.listForm.resetFields();
        //this.$refs.testForm.resetForm('listForm');
        this.dialogFormVisible = false;
      },
      getbusinessReviewer: function (data) {
        this.listForm.businessReviewer = data[0];
        this.listForm.businessReviewerName = data[1];
      },
      savePrivateInfo() {
        let childForm = this.$refs.editPage.$refs.editPage;
        console.log("childForm===", childForm)
        let formData = this.$refs.editPage.formData;
        console.log("formData=3-18==", formData)
        childForm.validate((valid) => {
          if (valid) {
            console.log("valid===", valid);
            updateRefundInfo(formData).then(res => {
              console.log("res~~~~~~~~", res)
              if (res.data.code==0) {
                this.dialogFormVisible = false
                this.$message.success('更新成功！');
                this._getListpage();
              } else {
                this.$message.error(res.data.msg);
              }
            })
          }
        })
      },
      // 得到复选框选的数据
      _getselect(selects) {
        this.selectRow = selects;
        console.log(selects);
      },
      updateBankInfo() {
        if (this.selectRow.length > 0) {
          this.loading = true;
          console.log("this.selectRow============");
          console.log(this.selectRow);
          var set = [];
          for (let i = 0; i < this.selectRow.length; i++) {
            if(this.selectRow[i].refundStatus!='30790001'){
              this.$message.error("只有新增的退票可以更新");
              this.loading = false;
              return false;
            }
            set.push(this.selectRow[i].backId)
          }
          updateBankInfo(set).then(res => {
            if (res.data.code == 0) {
              this.$message.success('更新成功！');
              this._getListpage();
              this.loading = false;
            } else {
              this.loading = false;
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$confirm('是否更新所有新增或退回的银行卡信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updateBankInfo([0]).then(res => {
              if (res.data.code == 0) {
                this.$message.success('更新成功！');
                this._getListpage();
                this.loading = false;
              } else {
                this.loading = false;
                this.$message.error(res.data.msg);
              }
            });
          }).catch(() => {

          });
      }
    },
    createPayoutBill() {
      if (this.selectRow.length > 0) {
        this.loading = true;
        console.log("this.selectRow============");
        console.log(this.selectRow);
        var set = [];
        for (let i = 0; i < this.selectRow.length; i++) {
          if (!this.selectRow[i].upOpenName || !this.selectRow[i].upBankType || !this.selectRow[i].upBankFullName || !this.selectRow[i].upAccountNumber) {
            this.$message.error("所选支出单未更新银行信息");
            this.loading = false;
            return;
          }
          if (this.selectRow[i].refundStatus != '30790001' && this.selectRow[i].refundStatus != '30790003') {
            this.$message.error("只有新增的退票可以创建支出单");
            this.loading = false;
            return;
          }
          set.push(this.selectRow[i].backId)
        }
        createPayoutBill(set).then(res => {
          if (res.data.code == 0) {
            this.loading = false;
            this.$message.success('创建成功！');
            this._getListpage();
            this.selectRow=[]
          } else {
            this.loading = false;
            this.$message.error(res.data.msg);
          }
        });
      } else {
        this.$message.error("请选择一条退票!");
      }

    },
    //导出表格
    exportTable() {
      //判断是否有勾选数据
      if (this.selectRow) {
        this.listQuery.dataList = this.selectRow;
      } else {
        this.listQuery.dataList = [];
      }
      console.log("this.listQuery=", this.listQuery)
      console.log("this.$refs['privateTable']=", this.$refs['privateTable'])
      var columns = JSON.parse(JSON.stringify( this.$refs['privateTable'].tableColums));
      for(var i = 0;i<columns.length;i++){
        if(!columns[i].field){
          columns.splice(i,1);
          i--;
        }
      }
      this.grounpColumn =Object.assign(this.grounpColumns1,this.grounpColumns2);
      for(var i = 0;i<columns.length;i++){
        if(columns[i].field=='remarks'){
         var count =  this.grounpColumns.length
          for(var j = (count-1) ;j>=0;j--){
            columns.splice(i,0,this.grounpColumns[j]);
          }
          break;
        }
      }
      console.log(this.grounpColumns);
      console.log(this.grounpColumns);
      console.log(columns);
      exportMethod({columns: columns, ...this.listQuery}, '/wage', true);
    },
  }
  }
</script>

<style scoped>

</style>
